import { render, staticRenderFns } from "./walletWithdrawalList.vue?vue&type=template&id=3afa788c&scoped=true&"
import script from "./walletWithdrawalList.vue?vue&type=script&lang=js&"
export * from "./walletWithdrawalList.vue?vue&type=script&lang=js&"
import style0 from "./walletWithdrawalList.vue?vue&type=style&index=0&id=3afa788c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afa788c",
  null
  
)

export default component.exports